import { StakeholderQueryProvider } from "__legacy/queries/stakeholders/StakeholderQueryProvider";
import { UpdateStakeholderMutationProvider } from "__legacy/queries/stakeholders/UpdateStakeholderMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { onError, onFinish, StakeholderForm } from "./StakeholderForm";

export const Edit: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <StakeholderQueryProvider variables={{ id }}>
      {({ stakeholder }) => (
        <UpdateStakeholderMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`Edit stakeholder ${stakeholder.companyName}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../")}>Back to details</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <StakeholderForm
                  action="update"
                  form={form}
                  handler={onFinish(mutate, {}, { id })}
                  values={stakeholder}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </UpdateStakeholderMutationProvider>
      )}
    </StakeholderQueryProvider>
  );
};
